/**
 * This function aims to solve a small issue with the dynamic Headline block
 * from Elementor Pro. This simply adds a non-breakable space (&nbsp;) at the
 * start and end of the dynamic element so the time Elementor calculate the
 * width the number returned is a bit bigger.
 */
const betterHeadlineDynamic = () => {
    const headlines = document.querySelectorAll('.elementor-widget-animated-headline');

    headlines?.forEach( headline => {
        let titles = headline.querySelectorAll('.elementor-headline-dynamic-text');
        titles?.forEach( title => {
            title.innerHTML = `<span>&nbsp;</span>${title.innerHTML.trim()}<span>&nbsp;</span>`;
        } );
    } );
}

export default betterHeadlineDynamic;